import { useMemo } from "react";

import useCellCopyAction from "../useCellCopyAction";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import { IacManagementGroup } from "../../components/Table/useIacTableStore/makeIacTableDataSlice/types";

const useGroupNameActions = (rowType: IacManagementGroup["__typename"], name: string) => {
  const column = useMemo(() => {
    switch (rowType) {
      case "ManagedEntitiesGroupedByProviders":
        return ResourcesSuggestions.Provider;
      case "ManagedEntitiesGroupedByStacks":
        return ResourcesSuggestions.StackName;
      case "ManagedEntitiesGroupedByTypes":
        return ResourcesSuggestions.ResourceType;
      case undefined:
      default:
        return ResourcesSuggestions.StackName;
    }
  }, [rowType]);

  const copyAction = useCellCopyAction(column, name);
  const filterAction = useCellFilterAction(column, name);

  return useMemo(() => [copyAction, filterAction], [copyAction, filterAction]);
};

export default useGroupNameActions;
